<template>
  <v-container fluid>
    <PageHeader :title="'Unit Group: ' + unitGroupName" icon="pie_chart" />
    <v-layout wrap>
      <v-flex xs12>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>Unit Group Info</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs10 md6 pl-3 pr-3>
                <v-subheader one-line class="subheading primary--text">
                  <div style="width:200px"><strong>Unit Group Name:</strong></div>
                  <div v-if="!isEdit">{{ unitGroupName }}</div>
                  <v-text-field v-if="isEdit" v-model="editName"></v-text-field>
                </v-subheader>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color='warning' v-if="!isEdit" @click="clickEditName()">
              <v-icon class="mr-1">edit</v-icon>{{ $t('Button.Edit') }}
            </v-btn>
            <v-btn color='success' v-if="isEdit" @click="saveEditName()">
              <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
            </v-btn>
            <v-btn color='primary' v-if="isEdit" @click="isEdit = false">{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 pt-4>
        <Subheader v-model="searchUnit" title="Units" search="in List:">
          <v-btn color="success" @click="clickAddUnit()">
            <v-icon class="mr-1">add</v-icon>{{ $t('Button.AddUnit') }}
          </v-btn>
        </Subheader>
        <v-card>
          <v-card-text>
            <v-data-table :headers="unitsHeaders" :items="unitGroup ? unitGroup.Units : []" :pagination.sync="pagination" :search="searchUnit">
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{props.item.Name}}</td>
                <td class="text-xs-right">
                  <v-btn dark color="delete" @click="clickRemove(props.item)">
                    <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Remove') }}
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 pt-4>
        <Subheader v-model="searchConvert" title="Conversion Equations" search="in List:">
          <!-- <v-btn style="float: right;" color="success" dark @click="addAlia()">Add</v-btn> -->
        </Subheader>
        <v-card>
          <v-card-text>
            <v-alert :value="true" icon="info" color="info">
              Unit pairs without conversion equations are highlighted.
            </v-alert>
            <v-data-table :headers="headers" :items="conversionInGroup" :search="searchConvert" hide-actions>
              <template slot="items" slot-scope="props">
                <tr :bgcolor=getColor(props.item)>
                  <td class="text-xs-left">{{props.item.FromUnit}}</td>
                  <td class="text-xs-left">{{props.item.ToUnit}}</td>
                  <td class="text-xs-left">{{props.item.Formula}}</td>
                  <td class="text-xs-right">
                    <v-btn color="warning" dark @click="editConvert(props.item)">
                      <v-icon class="mr-1">edit</v-icon>{{ $t('Button.Edit') }}
                    </v-btn>
                    <!-- <v-btn color="red" small dark @click="delelte(props.item)">delete</v-btn> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="addUnitDialog" persistent max-width="800">
        <v-card>
          <v-toolbar dense dark color="primary">
            <v-toolbar-title>{{ $t('UnitGroupDetail.addTitle') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="addUnitDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 pl-3 pr-3>
                <v-autocomplete label="Select Units" v-bind:items="remainUnit" v-model="addUnit" persistent-hint item-text="Name" item-value="Id" return-object></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="add" dark @click="addUnitToGroup()">
              <v-icon>done</v-icon>{{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" @click="closeDialog()" outline>{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="removeUnitDialog" persistent max-width="500">
        <v-card>
          <v-toolbar dense dark color="primary">
            <v-toolbar-title>{{ $t('UnitGroupDetail.deleteTitle') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="removeUnitDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>{{ $t('UnitGroupDetail.deleteMsg') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="delete" dark @click="removeUnitFromGroup()">
              <v-icon>delete_forever</v-icon>{{ $t('Button.Remove') }}
            </v-btn>
            <v-btn color="secondary" @click="removeUnitDialog = false" outline>{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editCovertDialog" persistent max-width="800">
        <v-card>
          <v-toolbar dense dark color="primary">
            <v-toolbar-title>{{ $t('UnitGroupDetail.editTitle') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="editCovertDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 pl-3 pr-3>
                <v-text-field label="From Unit" :value="formulaData.FromUnit" disabled></v-text-field>
                <v-text-field label="To Unit" :value="formulaData.ToUnit" disabled></v-text-field>
              </v-flex>
              <v-flex xs2 pl-3>
                <v-text-field label="Formula" :value='prefix' disabled></v-text-field>
              </v-flex>
              <v-flex xs10 pr-3>
                <HighlightTextField v-model="formulaData.Formula"></HighlightTextField>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="add" dark @click="updateCovert()">
              <v-icon>done</v-icon>{{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" @click="closeDialog()" outline>{{ $t('Button.Cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:left" auto-height :color="snackbar.snackbarColor" :timeout="null" top v-model="snackbar.isSnackbarShow">
        {{ snackbar.snackbarMessage }}
        <v-btn dark icon @click="hideSnackbar()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { errorMessage } from '@/helpers/exceptionHandling'
  import MessageUtil from '../mixins/MessageUtil'
  import HighlightTextField from '@/components/generic/HighlightTextField'
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  const unit = createNamespacedHelpers('unit')

  export default {
    components: {
      HighlightTextField,
      PageHeader,
      Subheader,
    },
    mixins: [MessageUtil],
    props: {
      unitGroupName: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        formulaData: {},
        searchUnit: '',
        searchConvert: '',
        editCovertDialog: false,
        removeUnitDialog: false,
        addUnitDialog: false,
        unitsHeaders: [{
          text: 'Unit Name',
          value: 'Name',
          align: 'left',
        },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        headers: [{
          text: 'From Unit',
          value: 'FromUnit',
          align: 'left',
        },
        {
          text: 'To Unit',
          value: 'ToUnitId',
          align: 'left',
        },
        {
          text: 'Formula',
          value: 'Formula',
          align: 'left',
        },
          // {
          //   text: "Unit Group",
          //   value: "UnitGroup",
          //   align: "left"
          // },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'FromUnit',
          rowsPerPage: 10,
        },
        addUnit: {},
        removeUnit: {},
        isEdit: false,
        editName: '',
      }
    },
    mounted() {
      if (this.allUnitGroupsIsLoad) {
        this.getUnitConversionByGroup(this.unitGroup.Id)
      }
    },
    computed: {
      ...unit.mapGetters(['allUnitGroups', 'unitDetail', 'allUnits', 'conversionInGroup', 'isLoadAllUnitGroups']),
      allUnitName() {
        let arr = []
        this.allUnits.forEach(e => {
          arr.push({
            Name: e.Groups.length == 0 ? e.Name : `${e.Name} ( ${this.getThisUnitGroupName(e.Groups).toString()} )`,
            Id: e.Id,
          })
        })
        return arr
      },
      allUnitGroupsIsLoad() {
        return this.allUnitGroups && this.allUnitGroups.length
      },
      remainUnit() {
        if (this.unitGroup) {
          return this.allUnitName.filter(x => {
            return this.unitGroup.Units.find(y => y.Id == x.Id) == null
          })
        }
      },
      unitGroup() {
        if (this.allUnitGroupsIsLoad) {
          return this.allUnitGroups.find(x => x.Name == this.unitGroupName)
        }
        return {
          Id: '',
          Name: '',
          Units: [],
        }
      },
      prefix() {
        return '[' + this.formulaData.ToUnit + ']  =  '
      },
    },
    watch: {
      isLoadAllUnitGroups() {
        if (this.allUnitGroupsIsLoad) {
          this.getUnitConversionByGroup(this.unitGroup.Id)
        }
      },
    },
    methods: {
      ...unit.mapActions(['postEditGroupCovertion', 'getUnitConversionByGroup', 'postEditUnitGroup']),
      getThisUnitGroupName(GroupList) {
        let arr = []
        GroupList.forEach(e => {
          arr.push(e.Name)
        })
        return arr
      },
      clickAddUnit() {
        this.addUnitDialog = true
      },
      clickRemove(data) {
        this.removeUnitDialog = true
        this.removeUnit = data
      },
      clickEditName() {
        this.isEdit = true
        this.editName = this.unitGroup.Name
      },
      saveEditName() {
        let unitGroupData = JSON.parse(JSON.stringify(this.unitGroup))
        let groupName = JSON.parse(JSON.stringify(this.allUnitGroups))
        let index = groupName.findIndex(x => x.Name == this.unitGroupName)
        groupName.splice(index, 1)
        let match = groupName.find(e => e.Name.toLowerCase() == this.editName.toLowerCase())
        if (!this.editName) {
          this.showSnackbar('Edit unit group request failed. Unit Group Name cannot be null, please enter Unit Group Name.', 'error')
        } else if (match) {
          this.showSnackbar(`Edit unit group request failed. Unit Group ${this.editName} already exists in the system, please enter correct Unit Group Name.`, 'error')
        } else {
          unitGroupData.Name = this.editName
          let options = {
            data: unitGroupData,
            successCb: () => {
              this.isEdit = false
              this.showSnackbar(`Save ${this.editName} successfully`, 'success')
              this.$router.push({
                name: 'UnitGroupDetail',
                params: {
                  unitGroupName: unitGroupData.Name,
                },
              })
            },
            failedCb: err => {
              this.showSnackbar(`Edit unit group request failed. ${errorMessage(err)}`, 'error')
            },
          }
          this.postEditUnitGroup(options)
        }
        
      },
      addUnitToGroup() {
        let unitGroupData = JSON.parse(JSON.stringify(this.unitGroup))
        unitGroupData.Units.push({
          Id: this.addUnit.Id,
          Name: this.addUnit.Name,
        })
        let options = {
          data: unitGroupData,
          successCb: () => {
            this.addUnitDialog = false
            this.showSnackbar(`Add unit ${this.addUnit.Name} to group successfully`, 'success')
            this.addUnit = {}
          },
          failedCb: err => {
            this.showSnackbar(`Add unit to group request failed. ${errorMessage(err)}`, 'error')
          },
        }
        this.postEditUnitGroup(options)
      },
      removeUnitFromGroup() {
        let unitGroupData = JSON.parse(JSON.stringify({
          ...this.unitGroup,
        }))
        let i = unitGroupData.Units.findIndex(x => x.Name == this.removeUnit.Name)
        unitGroupData.Units.splice(i, 1)
        let options = {
          data: unitGroupData,
          successCb: () => {
            this.removeUnitDialog = false
            this.showSnackbar(`Unit ${this.removeUnit.Name} removed successfully.`, 'success')
            this.removeUnit = {}
          },
          failedCb: err => {
            this.showSnackbar(`Remove unit from group request failed. ${errorMessage(err)}`, 'error')
          },
        }
        this.postEditUnitGroup(options)
      },
      updateCovert() {
        let options = {
          data: this.formulaData,
          successCb: () => {
            this.editCovertDialog = false
            this.showSnackbar(`Edit formula from ${this.formulaData.FromUnit} to ${this.formulaData.ToUnit} successfully`, 'success')
          },
          failedCb: (err) => {
            console.log(err)
            this.showSnackbar(`Edit formula request failed. ${errorMessage(err)}`, 'error')
          },
        }
        this.postEditGroupCovertion(options)
      },
      editConvert(data) {
        this.formulaData = JSON.parse(JSON.stringify(data))
        this.editCovertDialog = true
      },
      delelte() {},
      addAlia() {
        this.addUnitDialog = true
      },
      closeDialog() {
        this.addUnitDialog = false
        this.editCovertDialog = false
        this.addUnit = {}
      },
      getColor(data) {
        return !data.Formula ? '#FFE0B2' : '#ffffff'
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }
</style>